module.exports = __webpack_public_path__ + "static/media/edit.5e5325fa.svg";